import React from "react";
import { RadioGroup } from "@mui/material";
import { DsRadioButton } from "./DsRadioButton";

export type RadioOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

interface DsRadioGroupProps {
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  name: string;
}

export function DsRadioGroup({ options, value, onChange, name }: DsRadioGroupProps) {
  return (
    <RadioGroup
      value={value}
      onChange={(e) => onChange(e.target.value)}
      name={name}
    >
      {options.map((option) => (
        <DsRadioButton
          key={option.value}
          value={option.value}
          label={option.label}
          disabled={option.disabled}
        />
      ))}
    </RadioGroup>
  );
}
